import { useCallback } from "react";
import { useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { fetchDiscussion } from "~/store/actions/actions.discussions";
import { useGlobalPrivateChannelListener } from "../Hooks/useGlobalPrivateChannelListener";

export const DiscussionRealTime = ({ id, projectId }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const listener = useCallback(
    ({ id: discussionId, project_id = 0 }) => {
      if (discussionId === id) {
        dispatch(fetchDiscussion(project_id, id));
      }
    },
    [id, dispatch]
  );

  const invalidateNavigation = useCallback(
    ({ project_id = 0 }) => {
      if (projectId === project_id) {
        queryClient.invalidateQueries(["discussion-navigation", project_id, id]);
      }
    },
    [projectId, queryClient, id]
  );

  const invalidateForComments = useCallback(
    ({ parent_type, project_id }) => {
      if (parent_type === "Discussion" && projectId === project_id) {
        queryClient.invalidateQueries(["discussion-navigation", project_id, id]);
      }
    },
    [id, projectId, queryClient]
  );

  useGlobalPrivateChannelListener("DiscussionUpdated", listener);
  useGlobalPrivateChannelListener("DiscussionUpdated", invalidateNavigation);
  useGlobalPrivateChannelListener("DiscussionCreated", invalidateNavigation);
  useGlobalPrivateChannelListener("DiscussionMovedToProject", invalidateNavigation);
  useGlobalPrivateChannelListener("DiscussionRemovedFromProject", invalidateNavigation);
  useGlobalPrivateChannelListener("DiscussionMovedToTrash", invalidateNavigation);
  useGlobalPrivateChannelListener("DiscussionRestoredFromTrash", invalidateNavigation);

  useGlobalPrivateChannelListener("CommentCreated", invalidateForComments);
  useGlobalPrivateChannelListener("CommentUpdated", invalidateForComments);
  useGlobalPrivateChannelListener("CommentMovedToTrash", invalidateForComments);
  useGlobalPrivateChannelListener("CommentRestoredFromTrash", invalidateForComments);
  invalidateForComments;
  return null;
};

DiscussionRealTime.propTypes = {
  id: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
};
